import { render, staticRenderFns } from "./agentForm.vue?vue&type=template&id=12dcb9ca&scoped=true&"
import script from "./agentForm.vue?vue&type=script&lang=js&"
export * from "./agentForm.vue?vue&type=script&lang=js&"
import style0 from "./agentForm.vue?vue&type=style&index=0&id=12dcb9ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12dcb9ca",
  null
  
)

export default component.exports